export const SignUp = {
    email: '',
    password: '',
    firstName: '',
    lastName: '',
    phoneNumber: ''
}